import { createBrowserHistory } from 'history';
import analytics from '../util/analytics';

const history = createBrowserHistory();

let last = null;
let lastPath = null;
let lastSearchQuery = null;

export const previousURL = () => last;
export const previousPath = () => lastPath;
export const previousSearchQuery = () => lastSearchQuery;

history.listen((location, action) => {
  lastPath = location.pathname;
  lastSearchQuery = location.search;
  last = `${location.pathname}${location.search}${location.hash}`;
  analytics('set', 'page', location.pathname + location.search);
  analytics('send', 'pageview');
});

export default history;
